import { Badge, Button, Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';
import { RefreshCw } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useBooth } from '../hooks/useBooth';

export function FeatureFlagsCard() {
  const { t } = useTranslation();
  const { featureFlags, loadFeatureFlags } = useBooth();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await loadFeatureFlags();
    } finally {
      setIsRefreshing(false);
    }
  };

  if (!featureFlags) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>{t('settings.featureFlags.title')}</CardTitle>
        <Button
          variant="outline"
          size="sm"
          onClick={handleRefresh}
          disabled={isRefreshing}
          className="gap-2"
        >
          <RefreshCw className={`size-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          {t('settings.featureFlags.refresh')}
        </Button>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-3">
          {Object.entries(featureFlags).map(([key, detail]) => (
            <div key={key} className="flex flex-col gap-1 py-2 border-b last:border-b-0">
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm font-medium">{key}</span>
                <Badge variant={detail.enabled ? 'default' : 'secondary'}>
                  {detail.enabled
                    ? t('settings.featureFlags.enabled')
                    : t('settings.featureFlags.disabled')}
                </Badge>
              </div>
              {detail.description && (
                <span className="text-xs text-muted-foreground">{detail.description}</span>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
